import { render } from "./form-input.vue?vue&type=template&id=5a87fefe&ts=true"
import script from "./form-input.vue?vue&type=script&lang=ts"
export * from "./form-input.vue?vue&type=script&lang=ts"

import "./form-input.vue?vue&type=style&index=0&id=5a87fefe&lang=scss"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__